
import React, { useEffect, useState, useRef } from 'react';
import './Universities.css';
import axios from 'axios';
import { Field, Formik } from 'formik';

const Universities = ({ data }) => {
    const [isDragging, setIsDragging] = useState(false);  // To check if the mouse is being held down
    const startX = useRef(0);                             // To store the initial X position of the mouse
    const scrollLeft = useRef(0);                         // To store the initial scroll position
    const cardContainerRef = useRef(null);                // Reference to the card container for scrolling

    const [loading, setLoading] = useState(true);
    const [universities, setUniversities] = useState([]);
    const [optionCountries, setOptionCountries] = useState([]);

    const [countrySelected, setCountrySelected] = useState("");

    const URL_GET_UNIVERSITIES = `${process.env.REACT_APP_API_BASE_URL}api/studyabroad/public/request/universities`;
    const URL_GET_OPTIONCOUNTRIES = `${process.env.REACT_APP_API_BASE_URL}api/studyabroad/public/request/optioncountries`;


    const fetchData = async (URL) => {
        try {
            const response = await axios.get(URL);
            return response;
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(`${URL_GET_UNIVERSITIES}?country=${countrySelected}`).then((value) => {
            setUniversities(value.data);
        });
    }, [optionCountries, countrySelected]);

    useEffect(() => {
        fetchData(URL_GET_OPTIONCOUNTRIES).then((value) => {
            setOptionCountries(value.data);
        });
    }, []);



    // Handle mouse down event
    const handleMouseDown = (e) => {
        setIsDragging(true);
        startX.current = e.clientX;
        scrollLeft.current = cardContainerRef.current.scrollLeft;
    };

    // Handle mouse leave or up event
    const handleMouseUpOrLeave = () => {
        setIsDragging(false);
    };

    // Handle mouse move event to scroll the cards
    const handleMouseMove = (e) => {
        if (!isDragging) return;

        const x = e.clientX - startX.current;             // Calculate the distance moved
        cardContainerRef.current.scrollLeft = scrollLeft.current - x; // Move the container
    };

    if (loading) {
        return <div>Loading...</div>;
    }

    return (
        <section id='universities' className="universities-container">
            <h2 className="section-title">University</h2>

            <div className="select-container">
                {loading ? (
                    <h1>Loading...</h1>
                ) : (
                    <Formik>
                        <Field
                            as="select"
                            name="country"
                            className="my-1 p-2 block border border-gray-300 rounded-md focus:outline-none focus:ring focus:ring-blue-200"
                            onChange={(e) => {
                                setCountrySelected(e.target.value);
                            }}
                        >
                            <option value="" label="Pilih Negara" />
                            {optionCountries.map((country) => (
                                <option key={country.id} value={country.id}>
                                    {country.name}
                                </option>
                            ))}
                        </Field>
                    </Formik>
                )}
            </div>

            <div
                ref={cardContainerRef}
                className="card-container"
                onMouseDown={handleMouseDown}    // Start dragging on mouse down
                onMouseUp={handleMouseUpOrLeave} // Stop dragging on mouse up
                onMouseLeave={handleMouseUpOrLeave} // Stop dragging if mouse leaves the container
                onMouseMove={handleMouseMove}    // Update scroll position on mouse move
            >
                {universities?.length > 0 ? (
                    universities.map((university) => (
                        <div className="university-card" key={university.id}>
                            <div className="card-header">
                                <img
                                    className="university-logo"
                                    src={`${process.env.REACT_APP_API_BASE_URL}upload/${university.image_logo}`}
                                    alt={university.name}
                                />
                            </div>
                            <div className="card-body">
                                <h3>{university.name}</h3>
                                <div className="country-info">
                                    <img
                                        className="country-flag"
                                        src={`${process.env.REACT_APP_API_BASE_URL}upload/${university.image_flag}`}
                                        alt={university.country}
                                    />
                                    <p>{university.country}</p>
                                </div>
                                <p>{university.phone}</p>
                                <a className='m-1' href={`/university/${university.slug}`}>
                                    Learn More
                                </a>
                                <a href={university.website} target="_blank" rel="noopener noreferrer">
                                    Visit Website
                                </a>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No data found</p>
                )}
            </div>
        </section>
    );
};

export default Universities;
